module.exports = __webpack_public_path__ + "static/media/7up7down.07e79778.jpeg";